// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"fcef6395","160":"6a38f1c8","208":"ebc14fb6","293":"35dcd7cc","453":"fdd1cfa9","516":"53a3d61e","519":"7a5c90bd","885":"6034627b","917":"69bbc7c9","946":"3c752b53"}[chunkId] + ".chunk.js";
};